import { Box, Skeleton } from "@mui/material";

export const AccessKeySkeleton = () => (
    <Box sx={{ width: '100%' }}>
        <Skeleton sx={{ mb: 1 }} height={26} />
        <Skeleton sx={{ mb: 1 }} height={26} />
        <Skeleton sx={{ mb: 1 }} height={26} />
    </Box>
);